import React, { useState, useCallback, useEffect } from "react";

import { Link } from "gatsby";

import getFormattedDate from "sites-common/utils/FormatDate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRight,
  faCalendarAlt,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { Select, Label, Checkbox } from "theme-ui";
import Loader from "react-loader-spinner";
import moment from "moment";
import SelectComponent from "react-select";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import EventsListingBanner from "../components/events-listing/banner/index";
import Layout from "../layout/index";
import Seo from "../components/seo/index";
import sampleImg from "../assets/images/sample-temp-bg.png";

const getMandatoryEnv = require("sites-common/utils/getMandatoryEnv");

const { mySrcmConfig } = getMandatoryEnv(["kanhaStaticConfig"]);
const { eventsViewMoreBaseUri } = getMandatoryEnv(["eventsViewMoreBaseUri"]);

const shortDate = "shortDate";
const initalFilterVal = {
  status: "All",
  type: "All",
  language: {},
};

const itemsPerPage = 12;

const CustomDropdownIndicator = ({ innerProps }) => {
  const indicatorStyles = {
    cursor: "pointer",
    padding: "4px",
  };

  return (
    <div style={indicatorStyles} {...innerProps}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M7 10l5 5 5-5z" />
      </svg>
    </div>
  );
};
CustomDropdownIndicator.propTypes = {
  innerProps: PropTypes.shape({}).isRequired,
};

const viewMoreLink = (event) => {
  let link = "";
  if (event?.website_url) {
    link = event?.website_url;
  } else if (event?.reporting_only) {
    link = `${eventsViewMoreBaseUri}/event/connect?eid=${event?.id}`;
  } else if (!event?.reporting_only && event?.uep_event_sessions?.length > 0) {
    const batchSession =
      (Array.isArray(event?.uep_event_sessions) &&
        event?.uep_event_sessions?.find((e) => e?.session_no === 1)) ||
      "";
    link =
      batchSession && batchSession?.id
        ? `${eventsViewMoreBaseUri}/event-detail?eid=${event?.id}&batch=${batchSession?.id}`
        : `${eventsViewMoreBaseUri}/event?eid=${event?.id}`;
  } 

  const isExternal = link.includes("http");
  if (isExternal) {
    return (
      <a
        href={link}
        target="_blank"
        rel="noreferrer noopener"
        className="text-decoration-none"
      >
        View More
      </a>
    );
  }
  return (
    <Link to={link} className="text-decoration-none">
      View More
    </Link>
  );
};

const EventsListing = () => {
  const [eventsData, setEventsData] = useState({});
  const [filter, setFilter] = useState(initalFilterVal);
  const [topFilterVal, setTopFilterVal] = useState({});
  const [events, setEvents] = useState([]);
  const [languages, setLanguages] = useState([]);
  // const [searchedEvents, setSearchedEvents] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [topFilter, setTopFilter] = useState(false);
  const [recordCount, setRecordCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [showRegistrationsOpen] = useState(false);
  const [, setRegistrationsOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [URL, setURL] = useState(
    `${mySrcmConfig?.profileServer}/uep/public-recurring-events/?page=${page}&websites=kanhashantivanam&page_size=${itemsPerPage}`
  );
  const [selectedOption, setSelectedOption] = useState({
    value: "All",
    label: "All",
  });
  const htmlRegex = /<[^>]+>/;

  const handleSelectChange = (selectedOp) => {
    const languageOption = languages?.find(
      (i) => i?.value === selectedOp?.value
    );
    setFilter((prev) => ({
      ...prev,
      language: languageOption,
    }));
    setPage(1);
    setSelectedOption(languageOption);
  };

  // useEffect(() => {
  //   setLoading(true);
  //   axios
  //     .get(`${kanhaStaticConfig}/events.json`)
  //     .then((res) => {
  //       setEventsData(res?.data);
  //       setEvents(res?.data?.events);
  //       setLoading(false);
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //     });
  // }, []);

  const fetchData = useCallback((path, mainSearch = true) => {
    setLoading(true);
    axios
      .get(path)
      .then((res) => {
        const publicEventsData = res?.data?.results?.map((item) => {
          return {
            ...item,
            start_date: moment(item?.start_datetime).format("YYYY-MM-DD"),
            end_date: moment(item?.end_datetime).format("YYYY-MM-DD"),
          };
        });
        setRecordCount(res?.data?.count);
        if (mainSearch) {
          setEventsData(res?.data);
        }
        setEvents(publicEventsData);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    // if (topFilter) {
    //   fetchData(`${topFilter}&page=${page}&page_size=${itemsPerPage}`, false);
    // } else {
    //   fetchData(
    //     `${mySrcmConfig?.profileServer}/uep/public-recurring-events/?page=${page}&websites=kanhashantivanam&page_size=${itemsPerPage}`
    //   );
    // }
    fetchData(URL);
  }, [URL, fetchData]);

  const fetchLanguages = useCallback(() => {
    setLoading(true);
    axios
      .get(`${mySrcmConfig?.profileServer}/api/v2/languages/?page_size=100`)
      .then((res) => {
        const languageOptions = (res?.data?.results || [])?.map((i) => {
          return {
            id: i?.id,
            value: i?.code_iso,
            label: i?.name,
          };
        });
        setLanguages([
          {
            value: "All",
            label: "All",
          },
          ...languageOptions,
        ]);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchLanguages();
  }, [fetchLanguages]);

  useEffect(() => {
    let baseUrl = `${mySrcmConfig?.profileServer}/uep/public-events/?websites=kanhashantivanam`;
    if (filter !== initalFilterVal || Object.keys(topFilterVal)?.length > 0) {
      if (filter?.type === "Paid") {
        baseUrl += `&is_paid=true&ordering=-start_datetime&recurring_frequency=one-time`;
      }
      if (filter?.type === "Free") {
        baseUrl += `&is_paid=false&ordering=-start_datetime&recurring_frequency=one-time`;
      }
      if (filter?.language?.id) {
        baseUrl += `&languages=${filter?.language?.id}&ordering=-start_datetime&recurring_frequency=one-time`;
      }
      if (filter?.status === "Closed") {
        baseUrl += `&end_datetime__lt=${new Date().toISOString()}&recurring_frequency=one-time&ordering=-start_datetime`;
      }
      if (topFilterVal?.eventName) {
        baseUrl += `&search=${topFilterVal.eventName}`;
      }
      if (topFilterVal?.startDate) {
        baseUrl += `&start_datetime__gte=${new Date(
          topFilterVal.startDate
        ).toISOString()}&recurring_frequency=one-time&ordering=start_datetime`;
      }
      if (topFilterVal?.endDate) {
        baseUrl += `&end_datetime__lte=${new Date(
          topFilterVal.endDate
        ).toISOString()}&recurring_frequency=one-time&ordering=start_datetime`;
      }
      if (filter?.status === "Ongoing") {
        baseUrl += `&start_datetime__lte=${new Date().toISOString()}&end_datetime__gte=${new Date().toISOString()}&recurring_frequency=one-time&ordering=start_datetime`;
      }
      if (filter?.status === "Coming soon") {
        baseUrl += `&start_datetime__gte=${new Date().toISOString()}&recurring_frequency=one-time&ordering=start_datetime`;
      }
      if (
        filter.status === "All" &&
        filter.type === "All" &&
        filter?.language?.id === undefined &&
        Object.keys(topFilterVal)?.length === 0
      ) {
        setTopFilter(false);
        setURL(
          `${mySrcmConfig?.profileServer}/uep/public-recurring-events/?page=${page}&websites=kanhashantivanam&page_size=${itemsPerPage}`
        );
      } else {
        setTopFilter(true);
        setURL(`${baseUrl}&page=${page}&page_size=${itemsPerPage}`);
      }
      // setPage(1);
    } else {
      setURL(
        `${mySrcmConfig?.profileServer}/uep/public-recurring-events/?page=${page}&websites=kanhashantivanam&page_size=${itemsPerPage}`
      );
    }
  }, [filter, page, topFilterVal, topFilter]);

  // const filteredEvents = useMemo(() => {
  //   const sortEventsByFrequency = (localEvents) => {
  //     const sunDayEventsData = localEvents?.filter((data) => {
  //       if (data?.recurring && data?.frequency === "SUNDAY") {
  //         return data;
  //       }
  //       return "";
  //     });
  //     sunDayEventsData.sort((a, b) => {
  //       return parseFloat(b.id) - parseFloat(a.id);
  //     });
  //     const dailyEventsData = localEvents?.filter((data) => {
  //       if (data?.recurring && data?.frequency === "DAILY") {
  //         return data;
  //       }
  //       return "";
  //     });
  //     dailyEventsData.sort((a, b) => {
  //       return parseFloat(b.id) - parseFloat(a.id);
  //     });
  //     const monSatDaysEventsData = localEvents?.filter((data) => {
  //       if (data?.recurring && data?.frequency === "MON-SAT") {
  //         return data;
  //       }
  //       return "";
  //     });
  //     monSatDaysEventsData.sort((a, b) => {
  //       return parseFloat(b.id) - parseFloat(a.id);
  //     });
  //     const otherFrequentEvents = localEvents?.filter((data) => {
  //       if (
  //         data?.frequency !== "SUNDAY" &&
  //         data?.frequency !== "DAILY" &&
  //         data?.frequency !== "MON-SAT" &&
  //         data?.frequency !== ""
  //       ) {
  //         return data;
  //       }
  //       return "";
  //     });
  //     otherFrequentEvents.sort((a, b) => {
  //       return parseFloat(b.id) - parseFloat(a.id);
  //     });
  //     const allDaysEventsData = localEvents?.filter((data) => {
  //       if (
  //         data?.frequency !== "SUNDAY" &&
  //         data?.frequency !== "DAILY" &&
  //         data?.frequency !== "MON-SAT" &&
  //         data?.frequency === "" &&
  //         !data?.recurring
  //       ) {
  //         return data;
  //       }
  //       return "";
  //     });

  //     if (
  //       filter?.status === "Ongoing" ||
  //       filter?.status === "Coming soon" ||
  //       (searchedEvents.length && topFilter)
  //     ) {
  //       allDaysEventsData.sort(
  //         (a, b) =>
  //           new Date(a.start_date).getTime() - new Date(b.start_date).getTime()
  //       );
  //     } else {
  //       allDaysEventsData.sort(
  //         (a, b) =>
  //           new Date(b.start_date).getTime() - new Date(a.start_date).getTime()
  //       );
  //     }

  //     const allEventsDays = [
  //       ...sunDayEventsData,
  //       ...dailyEventsData,
  //       ...monSatDaysEventsData,
  //       ...otherFrequentEvents,
  //       ...allDaysEventsData,
  //     ];
  //     return allEventsDays;
  //   };

  //   const filterSortEvents = sortEventsByFrequency(events);
  //   return filterSortEvents?.slice(
  //     (page - 1) * itemsPerPage,
  //     (page + itemsPerPage - 1 - (page - 1)) * page
  //   );
  // }, [events, filter?.status, page, searchedEvents.length, topFilter]);

  // useEffect(() => {
  //   if (loading) {
  //     setTimeout(() => setLoading(false), 500);
  //   }
  // }, [loading]);

  // useEffect(() => {
  //   let ev = [];
  //   if (searchedEvents.length && topFilter) {
  //     ev = [...searchedEvents];
  //   } else if (
  //     eventsData?.results?.map((item) => {
  //       return {
  //         ...item,
  //         start_date: moment(item?.start_datetime).format("YYYY-MM-DD"),
  //         end_date: moment(item?.end_datetime).format("YYYY-MM-DD"),
  //       };
  //     }) &&
  //     !topFilter
  //   ) {
  //     ev = [
  //       ...eventsData?.results?.map((item) => {
  //         return {
  //           ...item,
  //           start_date: moment(item?.start_datetime).format("YYYY-MM-DD"),
  //           end_date: moment(item?.end_datetime).format("YYYY-MM-DD"),
  //         };
  //       }),
  //     ];
  //   }
  //   if (filter?.status && filter?.status !== "All" && ev.length) {
  //     if (filter?.status === "Ongoing") {
  //       ev = ev.filter(
  //         (a) =>
  //           new Date() >= new Date(a.start_date) &&
  //           new Date() <= new Date(a.end_date)
  //       );
  //     }
  //     if (filter?.status === "Coming soon") {
  //       setShowRegistrationsOpen(true);
  //       ev = ev.filter(
  //         (a) =>
  //           new Date() <= new Date(a.start_date) &&
  //           new Date() <= new Date(a.end_date)
  //       );
  //       if (registrationsOpen) {
  //         ev = ev.filter(
  //           (a) =>
  //             new Date() >= new Date(a.reg_start_date) &&
  //             new Date() <= new Date(a.reg_end_date)
  //         );
  //       }
  //     }
  //     if (filter?.status === "Closed") {
  //       ev = ev.filter(
  //         (a) =>
  //           new Date() >= new Date(a.start_date) &&
  //           new Date() >= new Date(a.end_date)
  //       );
  //     }
  //   }
  //   if (filter?.status && filter?.status !== "Coming soon") {
  //     setShowRegistrationsOpen(false);
  //   }
  //   if (filter?.type && filter?.type !== "All") {
  //     ev = ev.filter((a) => a.type === filter.type);
  //   }
  //   const filterLang = Object.entries(filter?.language || {})
  //     .filter(([, v]) => v)
  //     .map(([k]) => k);

  //   if (filterLang && filterLang.length) {
  //     ev = ev.filter((a) => {
  //       const curlan = a?.language || [];
  //       let contains = false;
  //       if (
  //         curlan &&
  //         (typeof curlan === "string" || curlan instanceof String)
  //       ) {
  //         if (filterLang.includes(lowerCase(curlan))) {
  //           contains = true;
  //         }
  //         // return null;
  //       } else if (curlan && curlan.length) {
  //         curlan.map((f) => {
  //           if (filterLang.includes(lowerCase(f))) {
  //             contains = true;
  //           }
  //           return null;
  //         });
  //       }
  //       return contains;
  //     });
  //   }
  //   setLoading(true);
  //   // setPage(1);

  //   // setEvents(ev);
  // }, [
  //   eventsData?.results,
  //   filter,
  //   registrationsOpen,
  //   searchedEvents,
  //   topFilter,
  // ]);

  // const findEventBy = useCallback(
  //   (fData) => {
  //     let baseUrl = `${mySrcmConfig?.profileServer}/uep/public-events/?websites=kanhashantivanam`;

  //     if (filter?.type === "Paid") {
  //       baseUrl = baseUrl + `&is_paid=true`;
  //     } else if (filter?.type === "Free") {
  //       baseUrl = baseUrl + `&is_paid=false`;
  //     }

  //     if (fData?.eventName) {
  //       baseUrl = baseUrl + `&search=${fData.eventName}`;
  //     }
  //     if (fData?.startDate) {
  //       baseUrl =
  //         baseUrl +
  //         `&start_datetime__gte=${moment(fData.startDate).format(
  //           "YYYY-MM-DD"
  //         )}`;
  //     }
  //     if (fData?.endDate) {
  //       baseUrl =
  //         baseUrl +
  //         `&end_datetime__lte=${moment(fData.endDate).format("YYYY-MM-DD")}`;
  //     }
  //     setTopFilter(baseUrl);
  //     setPage(1);
  //   },
  //   [eventsData?.events]
  // );
  //

  const clearTopFilter = useCallback(async () => {
    setEvents(
      eventsData?.results?.map((item) => {
        return {
          ...item,
          start_date: moment(item?.start_datetime).format("YYYY-MM-DD"),
          end_date: moment(item?.end_datetime).format("YYYY-MM-DD"),
        };
      })
    );
    // setSearchedEvents([]);
    setTopFilter(false);
    setLoading(true);
    setTopFilterVal({});
    setFilter(initalFilterVal);
    setPage(1);
    setSelectedOption({
      value: "All",
      label: "All",
    });
  }, [eventsData?.results]);

  const registrationsOpenChange = (e) => {
    setRegistrationsOpen(e.target.checked);
  };

  return (
    <>
      <Seo
        title="Events Listing"
        description="Kanha "
        pagepath="events-listing"
      />
      <Layout isSticky wrapperClass="home">
        <div className="book-a-stay">
          <EventsListingBanner
            findEventBy={(d) => setTopFilterVal(d)}
            clearFields={!topFilter}
            setPage={setPage}
          />
          <div className="events-listing-wr">
            <div className="container my-5">
              <div className="row">
                <div className="col-12">
                  <div className="mobile-filter-wrapper">
                    <h3>Events</h3>
                    <button
                      type="button"
                      className="filter-btn"
                      onClick={() => setShowFilter((prev) => !prev)}
                    >
                      Filter
                    </button>
                    {topFilter && (
                      <button
                        type="button"
                        className="filter-btn"
                        onClick={clearTopFilter}
                      >
                        Clear Filter
                      </button>
                    )}
                  </div>
                </div>
                <div
                  className={`col-12 col-lg-3 filter-section ${
                    showFilter ? "" : "hide"
                  }`}
                >
                  <h3>Filters</h3>
                  <h6 className="first_title">Event Status</h6>
                  <Select
                    name="status"
                    id="status"
                    defaultValue="All"
                    className="cust_dropdown"
                    value={filter?.status}
                    onChange={(e) => {
                      setFilter((prev) => ({
                        ...prev,
                        status: e.target.value,
                      }));
                      setPage(1);
                    }}
                  >
                    <option value="All">All</option>
                    <option value="Ongoing">Ongoing</option>
                    <option value="Coming soon">Coming soon</option>
                    <option value="Closed">Closed</option>
                  </Select>
                  <br />
                  {showRegistrationsOpen ? (
                    <>
                      <Label>
                        <Checkbox
                          defaultChecked={false}
                          onChange={(e) => registrationsOpenChange(e)}
                          // style={{ color: "#1c699f" }}
                        />{" "}
                        Registrations Open
                      </Label>
                      <br />
                    </>
                  ) : null}
                  <h6>Language</h6>
                  <SelectComponent
                    components={{ DropdownIndicator: CustomDropdownIndicator }}
                    options={languages}
                    onChange={handleSelectChange}
                    value={selectedOption}
                    className="languageBorder"
                    placeholder="Select a language"
                  />

                  <br />
                  <h6>Event Type</h6>
                  <Select
                    name="type"
                    id="type"
                    defaultValue="All"
                    className="cust_dropdown"
                    value={filter?.type}
                    onChange={(e) => {
                      setFilter((prev) => ({ ...prev, type: e.target.value }));
                      setPage(1);
                    }}
                  >
                    <option value="All">All</option>
                    <option value="Free">Free</option>
                    <option value="Paid">Paid</option>
                  </Select>
                  <br />
                </div>
                <div className="col-lg-9">
                  <div className="row">
                    <div className="col-12 desktop-view">
                      <h1 style={{ fontSize: "1.75rem" }}>Events</h1>
                      {topFilter && (
                        <button
                          className="filter-btn"
                          type="button"
                          onClick={clearTopFilter}
                        >
                          Clear Filter
                        </button>
                      )}
                    </div>
                    <p>
                      <strong>
                        For organizing events at Kanha Shanti Vanam, kindly
                        write to{" "}
                        <a href="mailto:eventmanager@heartfulness.org">
                          eventmanager@heartfulness.org
                        </a>
                      </strong>
                    </p>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="row">
                        {!loading && events?.length === 0 ? (
                          <p className="my-3 text-secondary">
                            No events available for your search.
                          </p>
                        ) : (
                          ""
                        )}
                        {loading ? (
                          <div className="cus_loading">
                            <div className="d-flex">
                              <Loader
                                type="Oval"
                                color="#74748a"
                                width={30}
                                height={25}
                              />
                              <span>&nbsp;Loading...</span>
                            </div>
                          </div>
                        ) : (
                          events?.map((item) => {
                            return (
                              <div
                                className="col-lg-4 col-md-6 col-sm-12 event_card_wrapper"
                                key={item?.id}
                              >
                                <div className="event-card-wr my-3">
                                  <div className="img_wrapper">
                                    <img
                                      src={item?.thumbnail_url || sampleImg}
                                      alt={item?.name}
                                    />
                                  </div>
                                  <div className="info-wr p-3">
                                    <strong title={item?.name}>
                                      {item?.name}
                                    </strong>
                                    <p className="mb-0">
                                      {item?.category?.name || "-"}
                                    </p>
                                    <div className="my-2 date_container">
                                      <FontAwesomeIcon
                                        icon={faCalendarAlt}
                                        color="#b0853a"
                                        width="20px"
                                        className="me-2"
                                        height="20px"
                                      />
                                      {item?.recurring_frequency ===
                                      "one-time" ? (
                                        <div>
                                          {item?.start_date !== "" &&
                                          item?.start_date !== null &&
                                          item?.start_date !== "Invalid date"
                                            ? getFormattedDate(
                                                item?.start_date,
                                                shortDate
                                              )
                                            : null}{" "}
                                          {item?.end_date !== "" &&
                                          item?.end_date !== null &&
                                          item?.end_date !== "Invalid date"
                                            ? "-"
                                            : null}{" "}
                                          {item?.end_date !== "" &&
                                          item?.end_date !== null &&
                                          item?.end_date !== "Invalid date"
                                            ? getFormattedDate(
                                                item?.end_date,
                                                shortDate
                                              )
                                            : null}
                                          {item?.end_date === "" &&
                                            item?.end_date !== null &&
                                            item?.end_date !== "Invalid date" &&
                                            item?.start_date === "" &&
                                            item?.start_date !== null &&
                                            item?.start_date !==
                                              "Invalid date" &&
                                            "-"}
                                        </div>
                                      ) : (
                                        `${item?.recurring_frequency.toUpperCase()}${
                                          item?.start_time
                                            ? `, ${moment(
                                                item?.start_time,
                                                "HH:mm:ss"
                                              ).format("h:mm A")}`
                                            : ""
                                        } ${
                                          item?.end_time
                                            ? `- ${moment(
                                                item?.end_time,
                                                "HH:mm:ss"
                                              ).format("h:mm A")}`
                                            : ""
                                        }`
                                      )}
                                    </div>
                                    <p className="">
                                      <span>Venue:</span> {item?.venue || "-"}
                                    </p>
                                    <p className="desc_wrap description_unset">
                                      {htmlRegex.test(item?.short_description)
                                        ? parse(item?.short_description)
                                        : item?.short_description}
                                    </p>
                                    {item?.recurring_frequency ===
                                    "one-time" ? (
                                      viewMoreLink(item)
                                    ) : (
                                      <span>&nbsp;</span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        )}
                      </div>
                    </div>
                  </div>
                  {recordCount !== 0 && recordCount > itemsPerPage ? (
                    <div className="cus_pagination">
                      <button
                        type="button"
                        disabled={page === 1}
                        onClick={() => {
                          window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                          });
                          setLoading(true);
                          setPage(page - 1);
                        }}
                      >
                        <FontAwesomeIcon icon={faArrowLeft} />
                      </button>
                      <button
                        type="button"
                        disabled={
                          page === Math.ceil(recordCount / itemsPerPage)
                        }
                        onClick={() => {
                          window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                          });
                          setLoading(true);
                          setPage(page + 1);
                        }}
                      >
                        <FontAwesomeIcon icon={faArrowRight} />
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

// EventsListing.propTypes = {
//   data: PropTypes.any.isRequired,
// };

export default EventsListing;
